module.exports = __webpack_public_path__ + "img/Tempo-Search.3bbb381b.svg";